<script>
export default {
  name: 'UlColSpace',
  props: {
    width: String,
  },
};
</script>
<template>
  <div class="ul-col-space" :style="{width: width}">
    <slot></slot>
  </div>
</template>
<style lang="scss">
  .ul-col-space {
    display: block;
    flex-shrink: 0;
  }
</style>
